import types from '../types/accessibilityActionTypes';

export const setAccessibilityControls = (payload) => {
  return { type: types.SET_ACCESSIBILITY, payload }
}
